'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (text) {
    return text.split(')').length > 1 ? text.split(')')[1] : text;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/misc/errorToString.js
// module id = 650
// module chunks = 0